// extracted by mini-css-extract-plugin
export default {"container":"TextLimitCounter_container__2ooPu","red":"TextLimitCounter_red__dJ54k","orange":"TextLimitCounter_orange__zOWrN"};